import { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";

function AdminRoute() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null); 

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      navigate("/admin/login"); 
    }
  }, []); 

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Outlet /> : null;
}

export default AdminRoute;
